import React from 'react'


const CreateChannelService = () => {
  const CreateChannel = (channelname) => {
    let tempchannel = new BroadcastChannel(channelname)
    window.channelList[channelname] = tempchannel
    return tempchannel 
    }
    const GetChannels = (channelname) => {
      let tempchannel = window.channelList[channelname];
      return tempchannel
    }

    return {
      CreateChannel,
      GetChannels
    };
  }

export default CreateChannelService